// pothos manager «Лимиты» — /api/getManagerLimits. Shipped читается из
// каталога pothos_assets (ADR-0034) через мост locale-map. Заморозки как
// понятия больше нет (решение Глеба 2026-07-19). week_new — загрузки в
// каталог за последние 7 дней (индикатор «в работе»); default(0) — чтобы
// новый фронт переживал старый ответ воркера в окне между деплоями.
import { z } from 'zod';

export const PothosLimitsRowSchema = z.object({
  locale_code: z.string(),
  language: z.string(),
  country: z.string(),
  priority: z.string(),
  category: z.string(),
  modality: z.string(),
  plan_target: z.number(),
  hard_limit: z.number(),
  shipped: z.number(),
  registered: z.number(),
  des_pending: z.number(),
  total: z.number(),
  remaining: z.number(),
  week_new: z.number().default(0),
});
export type PothosLimitsRow = z.infer<typeof PothosLimitsRowSchema>;

export const PothosLimitsPriorityTotalSchema = z.object({
  plan: z.number(),
  shipped: z.number(),
  registered: z.number(),
  des_pending: z.number(),
  total: z.number(),
  cells: z.number(),
});
export type PothosLimitsPriorityTotal = z.infer<typeof PothosLimitsPriorityTotalSchema>;

export const PothosLimitsSummarySchema = z.object({
  plan_total: z.number(),
  shipped_total: z.number(),
  registered_total: z.number(),
  des_pending_total: z.number(),
  total: z.number(),
  week_new_total: z.number().default(0),
});
export type PothosLimitsSummary = z.infer<typeof PothosLimitsSummarySchema>;

export const PothosManagerLimitsResSchema = z.object({
  rows: z.array(PothosLimitsRowSchema),
  summary: PothosLimitsSummarySchema,
  by_priority: z.record(z.string(), PothosLimitsPriorityTotalSchema),
  categories: z.array(z.string()),
  modalities: z.array(z.string()),
});
export type PothosManagerLimitsRes = z.infer<typeof PothosManagerLimitsResSchema>;
